import { AlertTriangle } from 'lucide-react';
import { cn } from '../../lib/cn';
import { EMAIL_IMPORT_BASIS, type EmailImportBasis } from '../../types/email.types';

interface SceltaBaseConsensoProps {
  valore: EmailImportBasis | null;
  onScegli: (base: EmailImportBasis) => void;
}

/**
 * "Perche' possiamo scrivergli": la stessa domanda nell'importazione e
 * nell'inserimento a mano, con le stesse risposte possibili. La risposta
 * finisce nel registro dei consensi e non si corregge piu'.
 */
export function SceltaBaseConsenso({ valore, onScegli }: SceltaBaseConsensoProps) {
  return (
    <div className="space-y-2">
      {EMAIL_IMPORT_BASIS.map((opzione) => (
        <button
          key={opzione.value}
          type="button"
          onClick={() => onScegli(opzione.value)}
          className={cn(
            'w-full text-left rounded-lg border p-3 transition-colors',
            valore === opzione.value
              ? 'border-primary-500 bg-primary-50/60 ring-1 ring-primary-500'
              : 'border-gray-200 hover:border-gray-300 bg-white'
          )}
        >
          <span className="block text-sm font-medium text-gray-900">{opzione.label}</span>
          <span className="block text-xs text-neutral-500 mt-0.5 leading-relaxed">
            {opzione.quando}
          </span>
        </button>
      ))}

      {valore === 'importazione_massiva' && (
        <div className="flex gap-3 rounded-lg border border-orange-200 bg-orange-50 p-3">
          <AlertTriangle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-orange-900 leading-relaxed">
            Entreranno come <strong>in attesa</strong>: non riceveranno nessuna campagna finche' non
            confermano l'iscrizione. E' la scelta giusta quando non sai da dove arriva l'indirizzo.
          </p>
        </div>
      )}
    </div>
  );
}
